import { useMutation } from '@tanstack/react-query'

import type {
  CreateUserParams,
  CreateUserResponse,
  UpdateUserParams,
  UpdateUserResponse,
} from '../services/api/api.types'
import type { MutationBaseOpts } from '../utils/tanstackHelpers'
import { handleMutationError, handleMutationSuccess } from '../utils/tanstackHelpers'
import { useGlobalState } from './useGlobalState'

export function useUserUpdateMutation(opts?: MutationBaseOpts<UpdateUserParams, UpdateUserResponse>) {
  const { api } = useGlobalState()

  return useMutation({
    mutationFn: api.updateUser,
    onSuccess: handleMutationSuccess('User was updated successfully.', [['users']], opts),
    onError: handleMutationError('Could Not Update User', opts),
  })
}

export function useUserCreateMutation(opts?: MutationBaseOpts<CreateUserParams, CreateUserResponse>) {
  const { api } = useGlobalState()

  return useMutation({
    mutationFn: api.createUser,
    onSuccess: handleMutationSuccess('User was created successfully.', [['users']], opts),
    onError: handleMutationError('Could Not Create User', opts),
  })
}
